import { FlexColumn, FlexRowCenter, OverflowText, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { orderBy } from "lodash";
import React, { FC, ReactElement } from "react";
import CustomViewAttribute from "./CustomViewAttribute";
import CustomViewAttributeGroup from "./CustomViewAttributeGroup";
import css from "./CustomViewAttributes.module.css";

interface AttributeGroupDragPreviewProps {
	attributes?: CustomViewAttribute[];
	group?: CustomViewAttributeGroup;
}

export const AttributeGroupDragPreview: FC<AttributeGroupDragPreviewProps> = ({
	attributes,
	group,
}): ReactElement => {
	// TODO: I don't know why this is needed, but will throw an error when dragging filter pane items
	if (!attributes?.length && !group?.attributes?.length) {
		return null;
	}
	const list = attributes || group.attributes;
	const sortedList = orderBy(list, ["order"], ["asc"]);
	const loc = useLocale();
	const attributesText = loc.resource("Attributes").toLocaleLowerCase();
	return (
		<FlexColumn
			className={css.attribute}
			justifyContent="center"
			style={{
				background: "var(--PrimaryWhite)",
				boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
				width: 272,
				zIndex: 1,
			}}
		>
			<FlexRowCenter gap={2} justifyContent="space-between">
				<FlexRowCenter>
					<Text
						noWrap
						text={`${sortedList.length} ${attributesText}`}
					/>
				</FlexRowCenter>
				<OverflowText
					minWidth={0}
					noWrap
					text={sortedList.map(({ spec }) => spec.name).join(", ")}
				/>
			</FlexRowCenter>
		</FlexColumn>
	);
};